var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Avatar, IconButton, LinearProgress, Button, styled } from "@mui/material";
import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons/faTrashAlt";
import { combineSxProps } from "../../Utils";
import { faFileAlt as fasFileAlt } from "@fortawesome/pro-solid-svg-icons/faFileAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const containerSxProps = {
    width: "100%",
    height: "100%",
    backgroundColor: "other.editorBackground",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "32px",
    gap: "16px"
};
const avatarDefaultSxProps = {
    backgroundColor: "common.white"
};
const topSectionWrapperSxProps = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px"
};
const textSectionWrapperSxProps = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px"
};
const loadingSectionWrapperSxProps = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    width: "100%"
};
const deleteButtonWrapperSxProps = {
    borderRadius: "50%",
    border: theme => `1px solid ${theme.palette.divider}`,
    backgroundColor: "common.white",
    position: "absolute",
    top: "-12px",
    right: "-12px"
};
const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.palette.primary.light
}));
export const FileUploaded = (props) => {
    const { DeleteButtonProps, avatarIcon, primaryText, secondaryText, loading, AbortButtonProps, ActionButtonProps, sx } = props, boxProps = __rest(props, ["DeleteButtonProps", "avatarIcon", "primaryText", "secondaryText", "loading", "AbortButtonProps", "ActionButtonProps", "sx"]);
    const _a = AbortButtonProps || {}, { label: abortButtonLabel } = _a, abortButtonPropsWithoutLabel = __rest(_a, ["label"]);
    const _b = ActionButtonProps || {}, { label: actionButtonLabel } = _b, actionButtonPropsWithoutLabel = __rest(_b, ["label"]);
    const _c = props.AvatarProps || {}, { sx: avatarSxProps } = _c, avatarPropsWithoutSx = __rest(_c, ["sx"]);
    const hasText = !!primaryText || !!secondaryText;
    return (_jsxs(Box, Object.assign({ sx: combineSxProps(containerSxProps, sx) }, boxProps, { children: [_jsxs(Box, { sx: topSectionWrapperSxProps, children: [_jsxs(Box, { sx: { position: "relative" }, children: [_jsx(Avatar, Object.assign({ sx: combineSxProps(avatarDefaultSxProps, avatarSxProps), variant: "rounded" }, avatarPropsWithoutSx, { children: avatarIcon !== null && avatarIcon !== void 0 ? avatarIcon : _jsx(StyledFontAwesomeIcon, { fontSize: "24px", icon: fasFileAlt }) })), _jsx(Box, { sx: deleteButtonWrapperSxProps, children: _jsx(IconButton, Object.assign({ color: "default", size: "small" }, DeleteButtonProps, { children: _jsx(FontAwesomeIcon, { style: { width: "14px", height: "14px" }, icon: faTrashAlt }) })) })] }), hasText && _jsxs(Box, { sx: textSectionWrapperSxProps, children: [_jsx(Typography, { variant: "subtitle1", color: "text.primary", align: "center", children: primaryText }), _jsx(Typography, { variant: "caption", color: "text.secondary", align: "center", children: secondaryText })] })] }), loading && _jsxs(Box, { sx: loadingSectionWrapperSxProps, children: [_jsx(LinearProgress, { variant: "indeterminate", sx: { width: "100%", maxWidth: "200px" } }), AbortButtonProps && (_jsx(Button, Object.assign({ size: "small" }, abortButtonPropsWithoutLabel, { children: abortButtonLabel })))] }), ActionButtonProps && (_jsx(Button, Object.assign({ variant: "contained" }, actionButtonPropsWithoutLabel, { children: actionButtonLabel })))] })));
};
//# sourceMappingURL=FileUploaded.js.map